import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useFlag } from "../../../../server/optimizely";
import { PermissionsTable } from "./permissions-table";

export const Permissions: FC = () => {
  const [reviewerRoleEnabled] = useFlag("reviewer_role");

  return (
    <>
      <Typography variant="h6">Manage your Permissions</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Users can add and remove user permissions here. Super Admins have site wide access, however
        Contributors can only view, edit and manage Communications in the Program assigned to them.
        {reviewerRoleEnabled ? " Reviewers can view and provide feedback on Communications." : null}
        <strong>
          {
            " New users permissions may not be immediate as they will be reviewed before being granted."
          }
        </strong>
      </Typography>
      <Box sx={{ mt: 3 }}>
        <PermissionsTable />
      </Box>
    </>
  );
};
